var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndersenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2567_3617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0825 32.21C24.9642 32.21 32.165 25.0091 32.165 16.1274C32.165 7.24574 24.9642 0.0449219 16.0825 0.0449219C7.20082 0.0449219 0 7.24574 0 16.1274C0 25.0091 7.20082 32.21 16.0825 32.21Z",
    fill: "#FEDA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4903 14.498C27.4426 12.9531 27.6024 9.76977 29.4243 7.32626C31.3931 10.0609 32.45 13.3468 32.4427 16.7164V17.3493C27.9741 16.3517 23.2934 17.0909 19.3498 19.4172C15.4061 21.7434 12.4949 25.4825 11.2065 29.876C11.0249 30.5058 10.8765 31.1471 10.7624 31.7924L10.3131 31.6161L9.99977 31.4853C7.21878 30.2776 4.8325 28.3137 3.1123 25.817C5.64193 26.5112 8.2971 26.618 10.8755 26.1304C8.96945 25.2785 4.56181 22.7873 4.50266 17.9293C7.14641 19.9698 10.3101 21.2266 13.6334 21.5567C12.0407 20.184 8.49009 16.5919 9.7632 11.8999C11.7404 14.5955 14.434 16.6825 17.5378 17.9241C16.3778 16.1893 13.9581 11.6986 16.467 7.55661C17.6229 10.6984 19.6357 13.4535 22.2775 15.5097C21.6383 13.5154 20.5385 8.5392 24.087 5.23242C24.3374 8.57741 25.516 11.7862 27.4903 14.498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2567_3617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7302,
    height: 31.912,
    fill: "white",
    transform: "translate(0 0.0449219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndersenLogo);
export default __webpack_public_path__ + "static/media/andersenLogo.8cca0bef6b82b790784c6fafa84a1699.svg";
export { ForwardRef as ReactComponent };